import React from "react";
var LittleArrow = function (_a) {
    var className = _a.className, color = _a.color;
    return (React.createElement("svg", { width: "8", height: "14", viewBox: "0 0 8 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: className },
        React.createElement("path", { d: "M7.93104 5.99488V8.0027L1.93616 14L0.0688477 12.1349L5.20372 7L0.0688477 1.86513L1.93616 0L7.93104 5.99488Z", fill: color })));
};
export default LittleArrow;
